export default "__VITE_ASSET__X8EdEF9Z__"